import React from 'react';
import { createPortal } from 'react-dom';
/** Error component for displaying (not only) http errors  */
export default props => createPortal(
    <div className="container fixed-bottom error-wrapper p-5 text-center">
        {props.children}
    </div>,
    document.getElementById('error-root')
)